import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button, Card, CardBody, CardTitle, Col, Container, Input, Label, Row, Spinner, Alert
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Autocomplete from "react-google-autocomplete";

// --- MESAFE HESAPLAMA (HAVERSINE FORMÜLÜ) ---
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; 
}

const TalepDuzenle = () => {
  document.title = "Talebi Düzenle | HarmanaGEL";
  const navigate = useNavigate();
  const { id } = useParams(); // URL'den güncellenecek ilanın ID'sini alıyoruz

  const GOOGLE_API_KEY = "AIzaSyAreftFsmXDb_jKD0kLYjQslxLkd-qwh08"; 
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userId = authUser?.ID;
  const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

  // --- STATE'LER ---
  const [loading, setLoading] = useState(true);
  const [publishing, setPublishing] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ visible: false, message: "", type: "success" });

  // ID'leri Tutma (Güncelleme işlemi için gerekli)
  const [locationId, setLocationId] = useState(null);
  const [basePricingId, setBasePricingId] = useState(null);
  const [existingUserPricings, setExistingUserPricings] = useState([]);

  // Rota ve Koordinatlar
  const [startAddress, setStartAddress] = useState("");
  const [startLat, setStartLat] = useState(0);
  const [startLng, setStartLng] = useState(0);

  const [endAddress, setEndAddress] = useState("");
  const [endLat, setEndLat] = useState(0);
  const [endLng, setEndLng] = useState(0);
  const [km, setKm] = useState("");

  // Ayarlar ve Görev Tipi
  const [settings, setSettings] = useState(null);
  const [advertTypes, setAdvertTypes] = useState([]);
  const [advertTypeId, setAdvertTypeId] = useState(null);
  const [basePrice, setBasePrice] = useState("0");

  // Zaman
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [timeStart, setTimeStart] = useState("");
  const [timeEnd, setTimeEnd] = useState("");

  // Araç
  const [cars, setCars] = useState([]);
  const [selectedCarId, setSelectedCarId] = useState(""); 
  const [carForm, setCarForm] = useState({
    carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: ""
  });

  // Ekstralar ve Müşteri Notu
  const [pricingOptions, setPricingOptions] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState({});
  const [advertNote, setAdvertNote] = useState("");

  // --- YARDIMCI FONKSİYONLAR ---
  const showAlert = (message, type = "success") => {
    setAlertConfig({ visible: true, message, type });
    setTimeout(() => setAlertConfig({ visible: false, message: "", type: "success" }), 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  const normalizePlate = (p) => (p || "").toUpperCase().replace(/\s+/g, "").replace(/-/g, "").trim();

  // --- API: VAR OLAN VERİYİ YÜKLEME ---
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        // 1. Ayarları, Araçları ve Ekstra Fiyatları Çek (Yeni görev ekranındaki gibi)
        const [typeRes, carRes, pricingRes, settingsRes] = await Promise.all([
            fetch(`${BASE_URL}/ILANLAR_Type`),
            fetch(`${BASE_URL}/KULLANICILAR_Car?$filter=KULLANICI_ID eq ${userId}&$orderby=ID desc`),
            fetch(`${BASE_URL}/ILANLAR_Pricing`),
            fetch(`${BASE_URL}/Settings?$top=1`)
        ]);

        const types = (await typeRes.json()).value || [];
        setAdvertTypes(types);

        const userCars = (await carRes.json()).value || [];
        setCars(userCars);

        const prices = (await pricingRes.json()).value || [];
        setPricingOptions(prices);

        const sysSettings = (await settingsRes.json()).value?.[0];
        setSettings(sysSettings);

        // 2. GÜNCELLENECEK İLANI ÇEK
        const advertRes = await fetch(`${BASE_URL}/ILANLAR?$filter=ID eq ${id}&$expand=ADRESLER,Users_Car`);
        const advertData = await advertRes.json();
        const advert = advertData.value?.[0];

        if (!advert) {
            showAlert("İlan bulunamadı!", "danger");
            return;
        }

        // İlan Bilgilerini Doldur
        setAdvertTypeId(advert.Advert_Type_ID);
        setAdvertNote(advert.Customer_Notes || "");

        // Tarih & Saat Doldurma
        if (advert.Advert_DateTime) {
            const stDate = new Date(advert.Advert_DateTime);
            setStartDate(stDate);
            setTimeStart(`${String(stDate.getHours()).padStart(2, '0')}:${String(stDate.getMinutes()).padStart(2, '0')}`);
        }
        if (advert.Advert_DateTime2) {
            const enDate = new Date(advert.Advert_DateTime2);
            setEndDate(enDate);
            setTimeEnd(`${String(enDate.getHours()).padStart(2, '0')}:${String(enDate.getMinutes()).padStart(2, '0')}`);
        }

        // Araç Doldurma
        if (advert.Car_ID) {
            setSelectedCarId(advert.Car_ID.toString());
            const c = advert.Users_Car || userCars.find(x => x.ID === advert.Car_ID);
            if (c) {
                setCarForm({
                    carPlate: c.PLAKA || "", carBrand: c.MARKA || "",
                    carModel: c.Users_Car_Model || "", carBodyType: c.Car_Body_Type || "",
                    engineType: c.Engine_Type || "", chassisInformation: c.ChassisInformation || ""
                });
            }
        }

        // Rota Doldurma
        const loc = advert.ADRESLER?.[0];
        if (loc) {
            setLocationId(loc.ID);
            setStartAddress(loc.ADRESLER_StartAddress || "");
            setStartLat(loc.ADRESLER_Lat_Start || 0);
            setStartLng(loc.ADRESLER_Long_Start || 0);

            setEndAddress(loc.ADRESLER_FinishAddress || "");
            setEndLat(loc.ADRESLER_Lat_Finish || 0);
            setEndLng(loc.ADRESLER_Long_Finish || 0);
            setKm(loc.Km?.toString() || "");
        }

        // 3. SEÇİLİ EKSTRALARI (Users_Advert_Pricing) ÇEK
        const uapRes = await fetch(`${BASE_URL}/KULLANICILAR_Advert_Pricing?$filter=ILANLAR_ID eq ${id}`);
        const uapData = await uapRes.json();
        const existingExtrasList = uapData.value || [];
        setExistingUserPricings(existingExtrasList); // İleride silmek için saklıyoruz

        const extrasMap = {};
        existingExtrasList.forEach(item => {
            extrasMap[item.Advert_Pricing_ID] = true;
        });
        setSelectedExtras(extrasMap);

      } catch (error) {
        console.error("Veri yükleme hatası:", error);
        showAlert("İlan bilgileri yüklenirken hata oluştu.", "danger");
      } finally {
        setLoading(false);
      }
    };

    if (id) loadData();
  }, [userId, id]);

  // Otomatik Mesafe Hesaplama
  useEffect(() => {
    if (startLat && startLng && endLat && endLng) {
      const calculatedDistance = getDistanceFromLatLonInKm(startLat, startLng, endLat, endLng);
      setKm(calculatedDistance.toFixed(2));
    }
  }, [startLat, startLng, endLat, endLng]);

  // Görev Tipi değiştiğinde Base Price güncelle
  useEffect(() => {
    if (!settings || !advertTypeId) return;
    const selectedType = advertTypes.find(t => t.ID === advertTypeId);
    const typeTitle = (selectedType?.Advert_Type_Title || "").toLowerCase();
    const isDriver = typeTitle.includes("sürücü") || typeTitle.includes("surucu");
    const price = isDriver ? settings.Km_Price_Car : settings.Km_Price_;
    setBasePrice(price?.toString() || "0");
  }, [settings, advertTypeId, advertTypes]);

  // Araç Seçimi Handle
  const handleCarSelect = (e) => {
    const val = e.target.value;
    setSelectedCarId(val);
    if (val !== "new" && val !== "") {
      const c = cars.find(x => x.ID.toString() === val);
      if (c) {
        setCarForm({
          carPlate: c.PLAKA || "", carBrand: c.MARKA || "",
          carModel: c.Users_Car_Model || "", carBodyType: c.Car_Body_Type || "",
          engineType: c.Engine_Type || "", chassisInformation: c.ChassisInformation || ""
        });
      }
    } else {
      setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
    }
  };

  // Fiyat Hesaplaması
  const totalPrice = useMemo(() => {
    const distance = parseFloat(km) || 0;
    const pricePerKm = parseFloat(basePrice) || 0;
    const subTotal = distance * pricePerKm;

    const extraTotal = pricingOptions.reduce((sum, item) => {
      const isSelected = !!selectedExtras[item.ID];
      const itemPrice = parseFloat(item.Price) || 0;
      return sum + (isSelected ? itemPrice : 0);
    }, 0);

    return subTotal + extraTotal;
  }, [km, basePrice, selectedExtras, pricingOptions]);

  // --- GÜNCELLEME İŞLEMİ (PATCH) ---
  const handleUpdate = async () => {
    if (!startAddress || !endAddress || !km || !carForm.carPlate || !advertTypeId) {
      showAlert("Lütfen rota ve araç bilgilerini eksiksiz doldurun.", "danger");
      return;
    }
    if (!startDate || !endDate || !timeStart || !timeEnd) {
      showAlert("Lütfen başlangıç ve bitiş tarih/saatlerini eksiksiz girin.", "danger");
      return;
    }

    setPublishing(true);
    try {
      const startDT = new Date(startDate);
      const [sh, sm] = timeStart.split(":");
      startDT.setHours(sh, sm, 0);

      const endDT = new Date(endDate);
      const [eh, em] = timeEnd.split(":");
      endDT.setHours(eh, em, 0);

      if (endDT <= startDT) {
        showAlert("Bitiş zamanı başlangıçtan sonra olmalıdır.", "danger");
        setPublishing(false);
        return;
      }

      // 1. Araç İşlemleri (Yoksa POST, Varsa PATCH)
      let finalCarId = selectedCarId === "new" || selectedCarId === "" ? null : parseInt(selectedCarId);

      if (!finalCarId) {
        const normPlate = normalizePlate(carForm.carPlate);
        const existing = cars.find(c => normalizePlate(c.PLAKA) === normPlate);
        
        if (existing) {
          finalCarId = existing.ID;
          // Mevcut aracı güncelle
          await fetch(`${BASE_URL}/KULLANICILAR_Car(${finalCarId})`, {
            method: "PATCH", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              MARKA: carForm.carBrand, Users_Car_Model: carForm.carModel, 
              Car_Body_Type: carForm.carBodyType, Engine_Type: carForm.engineType, 
              ChassisInformation: carForm.chassisInformation
            })
          });
        } else {
          // Yeni Araç Kaydet
          const carRes = await fetch(`${BASE_URL}/KULLANICILAR_Car`, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              PLAKA: carForm.carPlate, MARKA: carForm.carBrand,
              Users_Car_Model: carForm.carModel, Car_Body_Type: carForm.carBodyType,
              Engine_Type: carForm.engineType, ChassisInformation: carForm.chassisInformation,
              Users_ID: userId
            })
          });
          const carData = await carRes.json();
          finalCarId = carData?.value?.[0]?.ID || carData?.ID;
        }
      }

      const diffMs = endDT.getTime() - startDT.getTime();
      const totalMin = Math.max(0, Math.round(diffMs / 60000));
      const hh = String(Math.floor(totalMin / 60)).padStart(2, "0");
      const mm = String(totalMin % 60).padStart(2, "0");
      const estimatedDuration = `${hh}:${mm}`;

      // 2. İlanı Güncelle (PATCH Advert)
      await fetch(`${BASE_URL}/ILANLAR(${id})`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Advert_DateTime: startDT.toISOString(), Advert_DateTime2: endDT.toISOString(),
          Price: parseFloat(totalPrice.toFixed(2)), Advert_Type_ID: advertTypeId, 
          Car_ID: finalCarId, Estimated_Duration: estimatedDuration,
          Customer_Notes: advertNote
        })
      });

      // 3. Rotayı Güncelle (PATCH ADRESLER)
      if (locationId) {
          await fetch(`${BASE_URL}/KULLANICI_ADRESLERI(${locationId})`, {
            method: "PATCH", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              Km: parseFloat(km),
              ADRESLER_StartAddress: startAddress, ADRESLER_FinishAddress: endAddress,
              ADRESLER_Lat_Start: parseFloat(startLat), ADRESLER_Long_Start: parseFloat(startLng),
              ADRESLER_Lat_Finish: parseFloat(endLat), ADRESLER_Long_Finish: parseFloat(endLng)
            })
          });
      }

      // 4. Ekstraları Güncelleme (Önce eskileri sil, sonra yenileri ekle)
      for (let old of existingUserPricings) {
          await fetch(`${BASE_URL}/KULLANICILAR_Advert_Pricing(${old.ID})`, { method: "DELETE" });
      }

      const selectedPricingIds = Object.entries(selectedExtras).filter(([_, v]) => v).map(([k]) => Number(k));
      for (let pId of selectedPricingIds) {
        await fetch(`${BASE_URL}/KULLANICILAR_Advert_Pricing`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Advert_ID: parseInt(id), Advert_Pricing_ID: pId })
        });
      }

      showAlert("İlan başarıyla güncellendi!", "success");
      
      setTimeout(() => {
          navigate("/job-apply"); // Değişiklik sonrası Taleplerim listesine yönlendir
      }, 1500);

    } catch (error) {
      console.error("Güncelleme Hatası:", error);
      showAlert(error.message || "İşlem sırasında hata oluştu.", "danger");
      setPublishing(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Görevler" breadcrumbItem="Talebi Düzenle" />

          <Alert isOpen={alertConfig.visible} color={alertConfig.type} className="border-0 shadow-sm font-size-15">
            <i className={`mdi ${alertConfig.type === "success" ? "mdi-check-circle" : "mdi-alert-circle"} me-2`}></i>
            {alertConfig.message}
          </Alert>

          {loading ? (
             <div className="text-center py-5">
               <Spinner color="primary" />
               <p className="mt-2 text-muted">İlan verileri yükleniyor...</p>
             </div>
          ) : (
            <Row>
              <Col lg="8">
                
                {/* 1. GÖREV TİPİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-briefcase-outline text-primary me-2"></i>Görev Tipi</CardTitle>
                    <div className="d-flex flex-wrap gap-2">
                      {advertTypes.map((type) => (
                        <Button 
                          key={type.ID} 
                          color={advertTypeId === type.ID ? "primary" : "light"}
                          onClick={() => setAdvertTypeId(type.ID)}
                          className="px-4 py-2 fw-bold"
                        >
                          {type.Advert_Type_Title}
                        </Button>
                      ))}
                    </div>
                  </CardBody>
                </Card>

                {/* 2. ROTA PLANLAMASI */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-map-marker-path text-primary me-2"></i>Rota Planlaması</CardTitle>
                    <Row>
                      <Col md="12" className="mb-3">
                        <Label>Başlangıç Adresi</Label>
                        <div className="input-group">
                            <span className="input-group-text bg-light text-success"><i className="mdi mdi-circle-slice-8"></i></span>
                            <Autocomplete
                              apiKey={GOOGLE_API_KEY}
                              className="form-control"
                              placeholder="Yükleme adresi arayın..."
                              value={startAddress} // defaultValue yerine value
                              onChange={(e) => setStartAddress(e.target.value)}
                              onPlaceSelected={(place) => {
                                setStartAddress(place.formatted_address);
                                if (place.geometry?.location) {
                                  setStartLat(place.geometry.location.lat());
                                  setStartLng(place.geometry.location.lng());
                                }
                              }}
                              options={{ types: ["geocode", "establishment"], componentRestrictions: { country: "tr" } }}
                            />
                        </div>
                      </Col>
                      <Col md="12" className="mb-3">
                        <Label>Varış Adresi</Label>
                        <div className="input-group">
                            <span className="input-group-text bg-light text-danger"><i className="mdi mdi-map-marker"></i></span>
                            <Autocomplete
                              apiKey={GOOGLE_API_KEY}
                              className="form-control"
                              placeholder="Teslimat adresi arayın..."
                              value={endAddress} // defaultValue yerine value
                              onChange={(e) => setEndAddress(e.target.value)}
                              onPlaceSelected={(place) => {
                                setEndAddress(place.formatted_address);
                                if (place.geometry?.location) {
                                  setEndLat(place.geometry.location.lat());
                                  setEndLng(place.geometry.location.lng());
                                }
                              }}
                              options={{ types: ["geocode", "establishment"], componentRestrictions: { country: "tr" } }}
                            />
                        </div>
                      </Col>
                      <Col md="6">
                        <Label>Mesafe (KM)</Label>
                        <div className="input-group">
                            <Input type="number" placeholder="Otomatik hesaplanır..." value={km} disabled className="bg-light fw-bold text-primary" />
                            <span className="input-group-text bg-light fw-bold">KM</span>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 3. ZAMANLAMA */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-calendar-clock text-primary me-2"></i>Zaman Planlaması</CardTitle>
                    <Row>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Tarihi</Label>
                        <FlatPickr
                          className="form-control bg-light border-light"
                          placeholder="Tarih seçin"
                          value={startDate}
                          options={{ dateFormat: "Y-m-d", minDate: "today" }}
                          onChange={(date) => setStartDate(date[0])}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Saati</Label>
                        <Input type="time" className="bg-light border-light" value={timeStart} onChange={e => setTimeStart(e.target.value)} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Bitiş Tarihi</Label>
                        <FlatPickr
                          className="form-control bg-light border-light"
                          placeholder="Tarih seçin"
                          value={endDate}
                          options={{ dateFormat: "Y-m-d", minDate: startDate || "today" }}
                          onChange={(date) => setEndDate(date[0])}
                        />
                      </Col>
                      <Col md="6">
                        <Label>Bitiş Saati</Label>
                        <Input type="time" className="bg-light border-light" value={timeEnd} onChange={e => setTimeEnd(e.target.value)} />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 4. ARAÇ BİLGİLERİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <CardTitle className="mb-0 fw-bold"><i className="mdi mdi-car text-primary me-2"></i>Araç Bilgileri</CardTitle>
                        <Input type="select" className="w-auto fw-bold text-primary bg-soft-primary border-primary" value={selectedCarId} onChange={handleCarSelect}>
                            <option value="new">+ Yeni Araç Ekle</option>
                            {cars.map(c => <option key={c.ID} value={c.ID}>{c.PLAKA} ({c.MARKA})</option>)}
                        </Input>
                    </div>

                    <Row>
                      <Col md="12" className="mb-3">
                        <Label>Plaka</Label>
                        <Input type="text" placeholder="Örn: 34 ABC 123" className="fw-bold fs-5 text-uppercase bg-light border-light" value={carForm.carPlate} onChange={e => setCarForm({...carForm, carPlate: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Marka</Label>
                        <Input type="text" placeholder="Örn: BMW" className="bg-light border-light" value={carForm.carBrand} onChange={e => setCarForm({...carForm, carBrand: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Model</Label>
                        <Input type="text" placeholder="Örn: 3.20i" className="bg-light border-light" value={carForm.carModel} onChange={e => setCarForm({...carForm, carModel: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="4" className="mb-3">
                        <Label>Kasa Tipi</Label>
                        <Input type="text" placeholder="SUV / Sedan" className="bg-light border-light" value={carForm.carBodyType} onChange={e => setCarForm({...carForm, carBodyType: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="4" className="mb-3">
                        <Label>Motor Tipi</Label>
                        <Input type="text" placeholder="Elektrik vb." className="bg-light border-light" value={carForm.engineType} onChange={e => setCarForm({...carForm, engineType: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="4">
                        <Label>Şase No</Label>
                        <Input type="text" placeholder="WBA123..." className="bg-light border-light" value={carForm.chassisInformation} onChange={e => setCarForm({...carForm, chassisInformation: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 5. MÜŞTERİ NOTU */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">
                      <i className="mdi mdi-pencil-box-outline text-primary me-2"></i>Müşteri Notu (İsteğe Bağlı)
                    </CardTitle>
                    <Input 
                      type="textarea" 
                      rows="3" 
                      className="bg-light border-light" 
                      placeholder="Görevle veya araçla ilgili eklemek istediğiniz özel bir not ya da talep var mı?" 
                      value={advertNote} 
                      onChange={e => setAdvertNote(e.target.value)} 
                    />
                  </CardBody>
                </Card>

              </Col>

              {/* SAĞ TARAF - SİPARİŞ ÖZETİ VE EKSTRALAR */}
              <Col lg="4">
                
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-star-circle-outline text-warning me-2"></i>Ek Hizmetler</CardTitle>
                    {pricingOptions.map(item => (
                        <div 
                            key={item.ID} 
                            className={`p-3 mb-3 border rounded-3 d-flex align-items-center justify-content-between ${selectedExtras[item.ID] ? 'bg-soft-primary border-primary' : 'bg-light border-light'}`}
                            style={{ cursor: "pointer", transition: "all 0.2s" }}
                            onClick={() => {
                                setSelectedExtras(prev => ({
                                    ...prev,
                                    [item.ID]: !prev[item.ID] 
                                }));
                            }}
                        >
                            <div>
                                <h6 className="fw-bold mb-1">{item.Advert_Pricing_Title}</h6>
                                <p className="text-muted font-size-12 mb-1">{item.Advert_Pricing_Desc}</p>
                                <span className={`fw-bold font-size-13 ${selectedExtras[item.ID] ? 'text-primary' : 'text-secondary'}`}>
                                    {item.Price === 0 ? "Ücretsiz" : `+${item.Price} TL`}
                                </span>
                            </div>
                            <div className="form-check form-switch form-switch-md mb-0">
                                <Input 
                                    type="checkbox" 
                                    className="form-check-input" 
                                    style={{ cursor: "pointer", pointerEvents: "none" }}
                                    checked={selectedExtras[item.ID] || false} 
                                    onChange={() => {}} 
                                />
                            </div>
                        </div>
                    ))}
                  </CardBody>
                </Card>

                <div style={{ position: "sticky", top: "85px" }}>
                    <Card className="shadow-sm border border-warning rounded-4">
                    <CardBody className="p-4">
                        <h5 className="fw-bold text-center mb-4 text-warning">Düzenleme Özeti</h5>
                        
                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                            <span className="text-muted fw-bold">Baz Ücret ({basePrice} TL/Km)</span>
                            <span className="fw-bold text-dark">{((parseFloat(km)||0) * parseFloat(basePrice)).toFixed(2)} TL</span>
                        </div>

                        <div className="d-flex justify-content-between mb-4 border-bottom pb-2">
                            <span className="text-muted fw-bold">Ek Hizmetler</span>
                            <span className="fw-bold text-dark">
                                {pricingOptions.reduce((sum, item) => sum + (selectedExtras[item.ID] ? parseFloat(item.Price) : 0), 0).toFixed(2)} TL
                            </span>
                        </div>

                        <div className="text-center mb-4">
                            <span className="text-muted font-size-12 fw-bold d-block mb-1">YENİ TOPLAM TUTAR</span>
                            <h2 className="text-warning fw-900 mb-0">{totalPrice.toFixed(2)} TL</h2>
                        </div>

                        <Button color="warning" size="lg" className="w-100 fw-bold py-3 shadow d-flex justify-content-between align-items-center" onClick={handleUpdate} disabled={publishing}>
                            {publishing ? <Spinner size="sm" color="light" /> : <span>Değişiklikleri Kaydet</span>}
                            <i className="mdi mdi-content-save-edit-outline fs-4"></i>
                        </Button>
                    </CardBody>
                    </Card>
                </div>

              </Col>
            </Row>
          )}

        </Container>
      </div>
    </React.Fragment>
  );
};

export default TalepDuzenle;